import React from "react";
import Footer from './Footer'
import NaviBarv2 from './NaviBarv2'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import {Container, Row, Col, Card, ListGroup, ListGroupItem, Button, Tab, Nav,
OverlayTrigger, Popover, Placeholder} from 'react-bootstrap';
import Question from "../images/conf/Question.png"

export function Nesterova_info () {
  return (
        <>
    <NaviBarv2 />
    <Container>
      <section>
        <div><img src={Question} align="left" width={320} ></img></div>
        <div class="row my-4 ps-4"><h1>Нестерова Ангелина Витальевна</h1></div>
        <div class="row ps-4"><p>Инженер-исследователь</p><hr></hr></div>
        <div class="row ps-4"><h5>📩 a.v.nesterova@math.nsc.ru</h5><hr></hr>
        </div>
        <div class="row ps-4"><p><a href="https://ai-biolab.ru/data/Резюме_НестероваАВ.pdf">Резюме</a></p></div>
        </section>
        <div class="row ps-4"><p></p></div>
        <div class="row ps-4"><p></p></div>
        <div class="row ps-4"><p></p></div>
        <div class="row ps-4"><p></p></div>
        <div class="row ps-4"><p></p></div>
        <div class="row ps-4"><p></p></div>
        <hr></hr>
        <div class="row">
        <div class="col-sm-5 col-md-6"><div class="my-3"><h3>Образование</h3></div>
        <p>2017-2021 г. – Бакалавриат, Новосибирский государственный университет, Механико-математический факультет, Специальность: Механика и математическое моделирование.Название дипломной работы: Исследование граничных артефактов на реконструированных изображениях в эмиссионной томографии. Научные руководители: д.ф.-м.н., проф. Н. В. Денисова, д.ф.-м.н. О.И. Криворотько.</p>
        <p>2021–2023г. - Магистратура, Новосибирский государственный университет, Механико-математический факультет, Специальность: Прикладная математика и информатика. Название дипломной работы: Статистические подходы к решению обратной некорректной задачи реконструкции изображений в эмиссионной медицинской томографии. Научный руководитель: д.ф.-м.н., проф. Н. В. Денисова.</p>
        <p>2023–н.в. - Аспирантура, Институт математики им. С. Л. Соболева СО РАН. Научный руководитель: к.ф.-м.н., проф. П. С. Рузанкин.</p>
        </div>

        <div class="col-sm-5 offset-sm-2 col-md-6 offset-md-0"><div class="my-3"><h3>Профессиональный опыт</h3></div>
        <p> 2024 – н.в. - Инженер-исследователь, Лаборатория ИИ-технологий математического моделирования биологических, социально-экономических и экологических процессов, Институт математики им. С.Л. Соболева СО РАН, Новосибирск, Россия.</p>
        <p> 2024 – н.в. - Инженер-исследователь, Международный математический центр, Институт математики им. С.Л. Соболева СО РАН, Новосибирск, Россия.</p>
        <p> 2023 – Стажер-исследователь, Международный математический центр, Институт математики им. С.Л. Соболева СО РАН, Новосибирск, Россия.</p>
        <p>2022 – 2023 - Лаборант, Институт теоретической и прикладной механики имени С. А. Христиановича СО РАН, Новосибирск, Россия.</p>
        <p>2022 – 2024 - Лаборант, Лаборатория моделирования в ядерной медицине, Новосибирский государственный университет, Новосибирск, Россия.</p>
        <p>2021 – 2022 - Лаборант, Институт теоретической и прикладной механики имени С. А. Христиановича СО РАН, Новосибирск, Россия.</p>
        </div>
        </div>
        <hr></hr>
        <div class="row">
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0"><div class="my-3"><h3>Профессиональные интересы</h3></div>
        <p>Ядерная медицина.</p>
        <p>Однофотонная эмиссионная компьютерная томография.</p>
        <p>Статистические алгоритмы реконструкции изображений в эмиссионной томографии.</p>
        <p>Обратные задачи.</p>
        </div>
        <hr></hr>
        <div class="row">
          <div class="my-3"><h3>Исследовательские проекты и гранты</h3></div>
          <p>2024 - Новые подходы к улучшению и анализу изображений в ядерной медицине и компьютерной томографии на основе виртуальных клинических испытаний (при поддержке Математического центра в Академгородке в рамках соглашения № 075-15-2022-281 с Министерством науки и высшего образования Российской Федерации) - исполнитель.</p>
        </div>
        </div>
        </Container>
        

    <Footer />
    </>
    
    )}
    
    